import React from 'react';

function Contact1() {
  return (
    <div className="contact-page">
      <h2>Contact Us</h2>
      <p>
        If you have any questions or comments about our art, feel free to contact us.
      </p>
      <p>
        If you would like to purchase any of the art, please email us with the following information: 
        </p>
        <p>Your name, the art piece you are interested in, and the amount you are looking to spend on the art piece.
      </p>
      <p>
        You can reach us at any of the following. We look forward to hearing from you!
      </p>
      <p>
        Email: <a href="mailto:keglabas@outlook.com">keglabas@outlook.com</a>
      </p>
    </div>
  );
}

export default Contact1;
